/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Nogamestitle2Inputs */

const id_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada game ditemukan`)
};

const ms_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada permainan ditemui`)
};

const da_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen spil fundet`)
};

const de_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Spiele gefunden`)
};

const en_us2_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No games found`)
};

const es_es2_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron juegos`)
};

const es_mx2_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron juegos`)
};

const fil_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang laro`)
};

const fr_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun jeu trouvé`)
};

const it_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun gioco trovato`)
};

const hu_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található játék`)
};

const nl_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen games gevonden`)
};

const no_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen spill funnet`)
};

const pl_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono gier`)
};

const pt_br2_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo encontrado`)
};

const pt_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo encontrado`)
};

const ro_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit jocuri`)
};

const fi_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelejä ei löytynyt`)
};

const sv_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga spel hittades`)
};

const vi_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy game`)
};

const tr_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyun bulunamadı`)
};

const cs_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné hry`)
};

const bg_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени игри`)
};

const ru_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игры не найдены`)
};

const uk_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ігор не знайдено`)
};

const ar_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على ألعاب`)
};

const hi_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई गेम नहीं मिला`)
};

const th_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบเกม`)
};

const ja_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームが見つかりません`)
};

const zh_cn2_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到游戏`)
};

const zh_hant1_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到遊戲`)
};

const ko_profile_library_nogamestitle2 = /** @type {(inputs: Profile_Library_Nogamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임을 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "No games found" |
*
* @param {Profile_Library_Nogamestitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_nogamestitle2 = /** @type {((inputs?: Profile_Library_Nogamestitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Nogamestitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_nogamestitle2(inputs)
	if (locale === "ms") return ms_profile_library_nogamestitle2(inputs)
	if (locale === "da") return da_profile_library_nogamestitle2(inputs)
	if (locale === "de") return de_profile_library_nogamestitle2(inputs)
	if (locale === "en-US") return en_us2_profile_library_nogamestitle2(inputs)
	if (locale === "es-ES") return es_es2_profile_library_nogamestitle2(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_nogamestitle2(inputs)
	if (locale === "fil") return fil_profile_library_nogamestitle2(inputs)
	if (locale === "fr") return fr_profile_library_nogamestitle2(inputs)
	if (locale === "it") return it_profile_library_nogamestitle2(inputs)
	if (locale === "hu") return hu_profile_library_nogamestitle2(inputs)
	if (locale === "nl") return nl_profile_library_nogamestitle2(inputs)
	if (locale === "no") return no_profile_library_nogamestitle2(inputs)
	if (locale === "pl") return pl_profile_library_nogamestitle2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_nogamestitle2(inputs)
	if (locale === "pt") return pt_profile_library_nogamestitle2(inputs)
	if (locale === "ro") return ro_profile_library_nogamestitle2(inputs)
	if (locale === "fi") return fi_profile_library_nogamestitle2(inputs)
	if (locale === "sv") return sv_profile_library_nogamestitle2(inputs)
	if (locale === "vi") return vi_profile_library_nogamestitle2(inputs)
	if (locale === "tr") return tr_profile_library_nogamestitle2(inputs)
	if (locale === "cs") return cs_profile_library_nogamestitle2(inputs)
	if (locale === "bg") return bg_profile_library_nogamestitle2(inputs)
	if (locale === "ru") return ru_profile_library_nogamestitle2(inputs)
	if (locale === "uk") return uk_profile_library_nogamestitle2(inputs)
	if (locale === "ar") return ar_profile_library_nogamestitle2(inputs)
	if (locale === "hi") return hi_profile_library_nogamestitle2(inputs)
	if (locale === "th") return th_profile_library_nogamestitle2(inputs)
	if (locale === "ja") return ja_profile_library_nogamestitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_nogamestitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_nogamestitle2(inputs)
	return ko_profile_library_nogamestitle2(inputs)
});
export { profile_library_nogamestitle2 as "profile.library.noGamesTitle" }